import { Affix, Col, Row, Skeleton } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Platform } from "../../../constants/platform.constants";
import { ToastMessageType } from "../../../constants/toast-message.constants";
import { store } from "../../../modules";
import { posOrderDetailSelector, qrOrderSelector } from "../../../modules/order/order.reducers";
import { productListPageDataSelector } from "../../../modules/product/product.reducers";
import { setPackageExpiredInfo } from "../../../modules/session/session.actions";
import { useAppCtx } from "../../../providers/app.provider";
import { checkOutOfStockProductList } from "../../../services/material/check-out-of-stock.service";
import orderService from "../../../services/orders/order-service";
import posAddToCartServices from "../../../services/pos/pos-add-to-cart.services";
import posCartService from "../../../services/pos/pos-cart.services";
import mapperOutOfStockServicesQROrder from "../../../services/pos/pos-product-mapping.services";
import PackageExpiredDialog from "../../../shared/components/package-expired-dialog/package-expired-dialog.component";
import { isNonEmptyArray } from "../../../utils/helpers";
import { getStorage, localStorageKeys } from "../../../utils/localStorage.helpers";
import {
  ArrowLeftIcon,
  CheckCircleIcon,
  DiningTableIcon,
  StoreIcon,
  WarningTriangle
} from "../../assets/icons.constants";
import { BackIcon } from "../../assets/icons/BackIcon";
import DefaultLogo from "../../assets/images/coffee-mug-logo.png";
import ImageWithFallback from "../../components/fnb-image-with-fallback/fnb-image-with-fallback.component";
import MinHeader from "../../components/min-header/MinHeader";
import { CloseBranchContainer } from "../../containers/close-branch/close-branch.container";
import { useSearchParams } from "../../hooks";
import { EditOrderProductDialogComponent } from "../checkout/components/edit-order-product-dialog.component";
import BoxDrawer from "../order/components/BoxDrawer";
import ModeViewProductList from "../product-list-new/components/ModeViewProductList";
import MenuProductCategory from "./components/menuProductCategory/MenuProductCategory";
import ProductCategoryComponent from "./components/productCategory/ProductCategoryComponent";
import "./POSProductList.style.scss";

function POSProductListPage(props) {
  const { fontFamily } = props;
  const [t] = useTranslation();
  const history = useHistory();
  const { Toast } = useAppCtx();
  const viewDetailRef = useRef();
  const [categories, setCategories] = useState([]);
  const [dataMenuProductCategory, setDataMenuProductCategory] = useState([]);
  const [categoryIdSelected, setCategoryIdSelected] = useState(null);
  const [isVisibleBoxDrawerProductDetail, setIsVisibleBoxDrawerProductDetail] = useState(false);
  const productListPageData = useSelector(productListPageDataSelector);
  const [isLoadingProduct, setIsLoadingProduct] = useState(false);
  const reduxQROrder = useSelector(qrOrderSelector);
  const query = useSearchParams();
  const qrCodeId = query.get("qrCodeId");
  const orderId = query.get("orderId");
  const paramIsLoadData = "isLoadData";
  const isLoadQRCodeData = query.get(paramIsLoadData);
  const screenRatio = 2;
  const TIME_DELAY = 200;
  const posOrderDetail = useSelector(posOrderDetailSelector);
  const customerInfo = JSON.parse(getStorage(localStorageKeys.CUSTOMER_INFO));

  const [currentProductCategoryId, setCurrentProductCategoryId] = useState(null);
  const [selectProductCategoryId, setSelectProductCategoryId] = useState(null);
  const [isGridView, setIsGridView] = useState(true);

  const pageData = {
    order: t("order.order", "Đơn hàng"),
  };

  async function fetchQRCodeData(qrCodeId) {
    if ((qrCodeId && isLoadQRCodeData) || reduxQROrder?.branchId == null) {
      await orderService.getQrCodeOrderAsync(qrCodeId, false, posOrderDetail, query, history);
    }
  }

  async function initData() {
    if (reduxQROrder?.branchId || posOrderDetail?.branchId) {
      const request = {
        branchId: reduxQROrder?.branchId ?? posOrderDetail?.branchId,
      };
      await posCartService.fetchProductListPageDataAsync(request);
    }
  }

  useEffect(() => {
    posCartService.handelRemoveOrderInQrCode(qrCodeId, posOrderDetail, customerInfo);

    fetchQRCodeData(qrCodeId);
  }, [qrCodeId]);

  useEffect(() => {
    store?.dispatch(setPackageExpiredInfo(null));
    if (reduxQROrder) {
      if (qrCodeId === reduxQROrder?.qrCodeId || Boolean(orderId)) {
        posCartService.deleteUrlParam(query, history, paramIsLoadData);
      }
      const statusQrOrder = posCartService.checkStatusQrOrder(reduxQROrder);
      if (statusQrOrder && isLoadQRCodeData && qrCodeId === reduxQROrder?.qrCodeId) {
        handleShowToast(statusQrOrder);
      }
      initData();
    }
  }, [reduxQROrder]);

  useEffect(() => {
    if (productListPageData && productListPageData?.length > 0) {
      setIsLoadingProduct(true);
      setCategories(productListPageData);
      setDataMenuProductCategory(productListPageData);
      setCategoryIdSelected(productListPageData?.[0]?.id);
    }
  }, [productListPageData]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleShowToast(statusQrOrder) {
    const icon = statusQrOrder?.messageType === ToastMessageType.WARNING ? <WarningTriangle /> : <CheckCircleIcon />;
    Toast.show({
      messageType: statusQrOrder?.messageType,
      message: t(statusQrOrder?.message),
      icon: icon,
      placement: "bottom",
      duration: 3,
    });
  }

  function handleChangeProductCategoryTab(categoryId) {
    // scroll to content
    const element = document.getElementById("product-category-" + categoryId);
    if (element) {
      setSelectProductCategoryId(categoryId);
      setTimeout(() => {
        setSelectProductCategoryId(null);
      }, 1000);
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  async function handleShowProductDetail(item) {
    setIsVisibleBoxDrawerProductDetail(true);
    if (item?.isCombo) {
      const comboData = await posAddToCartServices.getComboDetailAsync(item?.id, item?.comboTypeId);
      setTimeout(() => {
        viewDetailRef?.current?.setProductData(comboData, -1);
      }, TIME_DELAY);
    } else {
      const productData = {
        isCombo: false,
        id: item?.id,
        quantity: 1,
        productPrice: {
          id: item?.productPriceDefault?.id,
          originalPrice: item?.productPriceDefault?.originalPrice,
          priceValue: item?.productPriceDefault?.sellingPrice,
          isApplyPromotion:
            item?.productPriceDefault?.discountAmount?.id !== null &&
            item?.productPriceDefault?.discountAmount?.id !== undefined,
          promotionId: item?.productPriceDefault?.discountAmount?.id,
          isDiscountPercent: item?.productPriceDefault?.discountAmount?.isPercentDiscount,
          discountValue: item?.productPriceDefault?.discountAmount?.isPercentDiscount
            ? item?.productPriceDefault?.discountAmount?.percentNumber
            : item?.productPriceDefault?.discountAmount?.maximumDiscountAmount,
        },
        toppings: [],
        options: [],
        branchId: reduxQROrder?.branchId,
      };
      setTimeout(() => {
        viewDetailRef?.current?.setProductData(productData, -1);
      }, TIME_DELAY);
    }
  }

  function handleCloseViewDetail() {
    setIsVisibleBoxDrawerProductDetail(false);
  }

  // In the mobile interface: when hiding/showing the toolbar
  // The height must be reassigned so that the interface does not break
  const windowHeight = () => {
    const element = document.documentElement;
    element.style.setProperty("--window-height", `${window.innerHeight}px`);
  };
  window.addEventListener("resize", windowHeight);
  windowHeight();

  const isElementInViewport = (element) => {
    const rect = element.getBoundingClientRect();

    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
  };

  const handleScroll = () => {
    const elements = document.querySelectorAll(".product-category");
    if (elements) {
      for (const element of elements) {
        const productCategoryLabel = element.querySelector(".product-category-name");
        if (isElementInViewport(productCategoryLabel)) {
          const productCategoryId = element.getAttribute("data-id");
          if (productCategoryId && currentProductCategoryId !== productCategoryId) {
            setCurrentProductCategoryId(productCategoryId);
          }
          break;
        }
      }
    }
  };

  // Out of stock
  const [productPrices, setProductPrices] = useState([]);

  async function fetchOutOfStockData(productPrices) {
    const outOfStockData = await checkOutOfStockProductList(
      reduxQROrder?.branchId ?? posOrderDetail?.branchId,
      true,
      productPrices,
    );
    setProductPrices(outOfStockData);
  }

  useEffect(() => {
    if (!isNonEmptyArray(categories)) return;
    const productPricesData = mapperOutOfStockServicesQROrder.mapperProducts2ProductVariantsFromCategories(categories);
    if (!isNonEmptyArray(productPricesData)) return;
    fetchOutOfStockData(productPricesData);
  }, [categories]);

  function onChangeGridView(isModeView) {
    setIsGridView(isModeView);
  }

  return (
    <>
      <div className="pos-product-list" style={{ fontFamily: fontFamily }}>
        <MinHeader
          addonBefore={
            <ArrowLeftIcon
              className="arrow-left-icon cursor-pointer"
              onClick={() => {
                history.push("/action-page?" + query.toString());
              }}
            />
          }
          addonBetween={
            reduxQROrder?.storeLogo && (
              <ImageWithFallback
                src={reduxQROrder?.storeLogo}
                alt="icon"
                fallbackSrc={DefaultLogo}
                className="logo-original-theme"
              />
            )
          }
        />
        <div className="pos-product-list-body" id="pos-product-list-body">
          <CloseBranchContainer branchId={reduxQROrder?.branchId} />
          <Col className="store-info">
            <Row className="store-info-title">
              <StoreIcon className="icon" />
              <span className="text">
                {reduxQROrder?.branchName || posOrderDetail?.branchName ? (
                  reduxQROrder?.branchName ?? posOrderDetail?.branchName
                ) : (
                  <Skeleton.Input active size="small" />
                )}
              </span>
            </Row>
            <Row className="order-area-name-content">
              <Col className="store-info-sub-title">
                <DiningTableIcon className="icon" />
              </Col>
              <Col className="store-info-sub-title" span={12}>
                <span className="text">
                  {reduxQROrder?.areaName || posOrderDetail?.areaName ? (
                    reduxQROrder?.areaName ?? posOrderDetail?.areaName
                  ) : (
                    <Skeleton.Input active size="small" />
                  )}
                </span>
              </Col>
              <Col className="order-code" span={9}>
                {posOrderDetail?.stringCode ? (
                  <>
                    {pageData.order}: {posOrderDetail?.stringCode}
                  </>
                ) : null}
              </Col>
            </Row>
          </Col>

          <Affix>
            <MenuProductCategory
              data={dataMenuProductCategory}
              categoryIdSelected={categoryIdSelected}
              productCategoryId={currentProductCategoryId}
              onChange={handleChangeProductCategoryTab}
            />
          </Affix>

          <div className="list-product-container" id="listProductContainer">
            {isLoadingProduct ? (
              <>
                <Affix offsetTop={60} className="view-mode-product-list-affix">
                  <ModeViewProductList isGridView={isGridView} onChangeGridView={onChangeGridView} />
                </Affix>
                {categories?.map((item) => {
                  return (
                    <ProductCategoryComponent
                      data={item}
                      key={item?.id}
                      handleShowProductDetail={handleShowProductDetail}
                      branchId={reduxQROrder?.branchId}
                      productPricesFirstTime={productPrices}
                      isGridView={isGridView}
                    />
                  );
                })}
              </>
            ) : (
              <>
                <div className="li-product-category">
                  <Skeleton active size="big" />
                </div>
              </>
            )}
          </div>
        </div>
        <BoxDrawer
          closeIcon={<BackIcon />}
          closable={true}
          className="edit-cart-item-box-drawer"
          title={""}
          height={"100%"}
          open={isVisibleBoxDrawerProductDetail}
          onClose={handleCloseViewDetail}
          destroyOnClose={true}
          style={{ fontFamily: fontFamily }}
          body={
            <EditOrderProductDialogComponent
              ref={viewDetailRef}
              onCancel={handleCloseViewDetail}
              setCurrentCartItems={() => { }}
              isPOS={true}
              branchIdPos={reduxQROrder?.branchId}
              platformId={Platform.POS}
              fontFamily={fontFamily}
            />
          }
        />
      </div>
      <PackageExpiredDialog />
    </>
  );
}

export default React.memo(POSProductListPage, (prevProps, nextProps) => true);
